import React, { Component } from "react";
import {
  Table,
  Input,
  Select,
  DatePicker,
  Modal,
  Tooltip,
  Form,
  Menu,
  Dropdown,
  Checkbox,
  Spin,
} from "antd";
import LayoutOperation from "../../components/layout_operation";
import ServiceApi from "../../services/ServiceApi";
import Cookies from "js-cookie";
import moment from "moment";
function isEmpty(obj) {
  for (var prop in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, prop)) {
      return false;
    }
  }

  return JSON.stringify(obj) === JSON.stringify({});
}

class SelectAssign extends Component {
  formRef = React.createRef();
  constructor(props) {
    super(props);
    this.state = {
      list_vendor: [],
      job_id: "",
      selectedRowKeys: [],
      selectedRows: [],
      visible: false,
      active_tab_skill: 1,
      ma_skill: [],
      ma_team: [],
      active_emp_skill: 0,
      active_tab_skill: 1,
      startDate: new Date(),
      data_assing: [],
      modal_data: [],
      emp_assign: [],
      Checktab: 1,
      statustab: 1,
      columns_employee: [
        {
          title: "",
          dataIndex: "",
          key: "",
          render: (item) => (
            <Checkbox
              onChange={() => this.CheckboxAsset(item)}
              checked={item["status_checkbox"]}
            ></Checkbox>
          ),
        },
        {
          title: "Emp Code",
          dataIndex: "emp_code",
          key: "emp_code",
        },
        {
          title: "Name",
          dataIndex: "emp_name",
          key: "emp_name",
        },
        {
          title: "Nick Name",
          dataIndex: "emp_nickname",
          key: "emp_nickname",
        },
        {
          title: "Skill",
          dataIndex: "ma_skill_name",
          key: "ma_skill_name",
        },
        {
          title: "Team Name",
          dataIndex: "team_name",
          key: "team_name",
        },
        {
          title: "Status",
          dataIndex: "",
          key: "",
          render: (item) => (
            <span>
              {item.working_status === "WO" ? (
                <span className="c-green">
                  <span className="dot-active mr-2"></span>Active
                </span>
              ) : (
                <span className="c-red">
                  <span className="dot-Inactive mr-2"></span> In Active
                </span>
              )}
            </span>
          ),
        },
        {
          title: "On Hand Job",
          dataIndex: "current_onhand_job",
          key: "current_onhand_job",
        },
      ],
      columns_team: [
        {
          title: (
            <Checkbox onChange={() => this.CheckboxAsset("all")}></Checkbox>
          ),
          dataIndex: "",
          key: "",
          render: (item) => (
            <Checkbox
              onChange={() => this.CheckboxAsset(item)}
              checked={item["status_checkbox"]}
            ></Checkbox>
          ),
        },
        // {
        //   title: "Team Group Name",
        //   dataIndex: "team_group_name",
        //   key: "team_group_name",
        // },
        {
          title: "Team Sub Name",
          dataIndex: "team_sub_name",
          key: "team_sub_name",
        },
        {
          title: "Name List",
          dataIndex: "emp_name",
          key: "emp_name",
        },
        {
          title: "Status",
          dataIndex: "",
          key: "",
          render: () => (
            <span className="c-green">
              <span className="dot-active mr-2"></span>Active
            </span>
          ),
        },
        {
          title: "On Hand Job",
          dataIndex: "current_onhand_job",
          key: "current_onhand_job",
        },
      ],
      selectedRowlist: [],
      data: [],
      visible_success: false
    };
  }
  async componentDidMount() {
    const qury_process = [
      "",
      "and job_status  not in (999)",
      "and job_status  in (2,3)",
      "and job_status  in (1)",
    ];
    const GetMaskill = await ServiceApi.post("get_ma_skill", {
      pk_id: null,
      is_active: 1,
      effective: null,
      sql_where: "operator_id = " + Cookies.get("operator_id"),
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
    });
    const GetMaTeam = await ServiceApi.post("get_team_group", {
      pk_id: null,
      is_active: "1",
      effective: null,
      sql_where: null,
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
    });
    if (GetMaTeam.data.result.value === "P") {
      this.setState({ ma_team: GetMaTeam.data.data.team_group_list });
    }
    if (GetMaskill.data.result.value === "P") {
      this.setState({ ma_skill: GetMaskill.data.data.result_ma_skill_list });
      await this.onChangEmp(1, 0);
    }

    const getalljob = await ServiceApi.post("oper_get_query_group_list", {
      company_id: Cookies.get("companyid"),
      operator_id: 0,
      project_id: 0,
      query_module: "oper",
      query_id: "2,3,4,5,6",
      param_text:
        "@company_id:$" +
        localStorage.getItem("companyid") +
        "##@operator_id:$" +
        localStorage.getItem("operator_id") +
        "##@project_id:$" +
        localStorage.getItem("project_id") +
        "##@select:$null##@job_status_id:$null##@category_id:$null##@date:$null##@job_type:$null##@priority_id:$null##@create_by:$18##@job_sub_type_id:$null##@sql_where:$'and (job_status in ( 1))'",
      where_cond: "",
    });

    this.setState({
      data: getalljob.data.data.result_ma_job_list,
    });
  }

  onAssignJob() {
    var setJob = localStorage.getItem("mapID").split(",").filter((data) => data !== "");
    var setData = [];
    for (let i = 0; i < setJob.length; i++) {
      var JobID = this.state.data.filter((data) => data.job_id === parseInt(setJob[i]));
      setData.push(JobID[0]);
    }

    this.setState({
      job_id: "Total : " + setData.length + " Job.",
      selectedRowlist: setData
    });
    this.onModal(true, null, "assignMulti");
  }
  onModal = async (visible, item, name) => {
    const get_vendor = await ServiceApi.post("get_vendor", {
      company_id: Cookies.get("companyid"),
      operator_id: null,
      project_id: null,
      vendor_id: null,
      vendor_code: null,
      vendor_name: null,
      vendor_address: null,
      v_where: null,
    });

    this.setState({
      list_vendor: get_vendor.data.data.result,
      visible: visible,
      data_assing: this.state.data_assing,
      modal_data: [],
    });

    if (name === "assignMulti" || name === "Wait Ack Job Multi") {
      // var setJobId = "";
      var subid = "";
      var WorkFlow_Loop = [];
      var prev_wf_id = null;
      var prev_main_process_id = null;
      var prev_sub_process_id = null;
      var prev_workflow = [];

      this.state.selectedRowlist.sort((a, b) =>
        a.wf_id > b.wf_id ? 1 : b.wf_id > a.wf_id ? -1 : 0
      );
      for (var i = 0; i < this.state.selectedRowlist.length; i++) {
        // setJobId += this.state.selectedRowlist[i].job_no + ",";
        subid =
          this.state.selectedRowlist[i].subprocessid === null
            ? (subid = "-1")
            : (subid = this.state.selectedRowlist[i].subprocessid);

        if (
          this.state.selectedRowlist[i].wf_id != prev_wf_id &&
          this.state.selectedRowlist[i].main_process_id !=
          prev_main_process_id &&
          subid != prev_sub_process_id
        ) {
          const getBtn = await ServiceApi.post("getButtonDetailWeb", {
            WF_ID: this.state.selectedRowlist[i].wf_id,
            CompanyID: this.state.selectedRowlist[i].company_id,
            ProjectID: this.state.selectedRowlist[i].project_id,
            JobTypeID: this.state.selectedRowlist[i].job_type_id,
            MainProcessID:
              this.state.selectedRowlist[i].main_process_id === null
                ? 1
                : this.state.selectedRowlist[i].main_process_id,
            SubProcessID: subid,
            ActionID: this.state.selectedRowlist[i].actionid,
            UserName: Cookies.get("username"),
          });

          var checkflow = getBtn.data.return_nextWorkFlow.find(
            (element) =>
              element.next_main_action_name === "Assign" ||
              element.next_main_action_name === "Reassign" ||
              element.from_main_process_name === "Wait Ack Job"
          );
          WorkFlow_Loop.push(checkflow);
          prev_wf_id = this.state.selectedRowlist[i].wf_id;
          prev_main_process_id = this.state.selectedRowlist[i].main_process_id;
          prev_sub_process_id = subid;
          prev_workflow = checkflow;
        } else {
          WorkFlow_Loop.push(prev_workflow);
        }
      }

      await this.setState({
        loading_checklist: false,
        visible: visible,
        job_id: "Total " + this.state.selectedRowlist.length + " Jobs",
        modal_data: this.state.selectedRowlist,
        data_wf: WorkFlow_Loop,
        btnName:
          name === "Wait Ack Job Multi"
            ? "Edit Employee"
            : checkflow.next_main_action_name,
      });
    }
  };
  renderModalAssign() {
    const { visible, job_id, selectedRowKeys, selectedRows } = this.state;
    const rowSelection = {
      selectedRowKeys,
      selectedRows,
      onChange: this.onSelectChange,
      getCheckboxProps: (record) => ({
        disabled: record.name === "Disabled User",
        name: record.name,
      }),
    };
    const dateFormatList = ["DD/MM/YYYY", "DD/MM/YY"];
    return (
      <Modal
        title={null}
        centered
        visible={visible}
        footer={null}
        closable={false}
        width={1000}
        className="custom-modal-map-large"
      >
        <div className="row">
          <div className="col-12">
            {" "}
            <h5 className="font-mont-b font14 c-blue text-uppercase mt-4 ml-4">
              Assign Job : {job_id}
            </h5>
          </div>
          <div className="col-3">
            {/* <AssignJob data={this.state.modal_data} /> */}
            <div className="row  mt-2 ml-4">
              <div
                className={
                  this.state.active_tab_skill === 1
                    ? "col-6 setAcive"
                    : "col-6 setnonAcive"
                }
                onClick={() => this.setDataTabEMP(1)}
              >
                <span>Employee</span>{" "}
              </div>
              <div
                className={
                  this.state.active_tab_skill === 2
                    ? "col-6 setAcive"
                    : "col-6 setnonAcive"
                }
                onClick={() => this.setDataTabEMP(2)}
              >
                <span>Team</span>{" "}
              </div>
            </div>
            <div className="row  mt-2 ml-4 setoverflowCard">
              {this.state.ma_skill.map((item, index) => (
                <div
                  className="col-12"
                  onClick={() => this.onChangEmp(item.ma_skill_id, index)}
                  key={index}
                >
                  <div
                    className={
                      this.state.active_emp_skill === index
                        ? "boxcradAcive mb-2"
                        : "boxcradnonAcive mb-2"
                    }
                  >
                    <span
                      className={
                        this.state.active_emp_skill === index
                          ? "settextcardActive mb-2"
                          : "settextcardnonActive mb-2"
                      }
                    >
                      {item.ma_skill_name}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="col-9">
            <div style={{ padding: "20px" }}>
              <div className="row">
                <div className="col-auto ">
                  <h5 className="font-mont-b fs-10 c-blue text-uppercase mt-2">
                    Assign Date :
                  </h5>
                </div>
                <div className="col-4 ">
                  <DatePicker
                    onChange={(e) => this.setState({ assign_date: e })}
                    style={{ color: "#000F9F" }}
                    name="date"
                  />
                </div>
                <div className="col-auto">
                  <h5 className="font-mont-b fs-10 c-blue text-uppercase mt-2">
                    Assign Vendor :
                  </h5>
                </div>
                <div className="col-4">
                  <Select
                    showSearch
                    style={{ border: "0px", width: "100%", color: "#000F9F" }}
                    placeholder="Please Select"
                    className="inputfile"
                    onChange={(value) => this.setState({ vendor_id: value })}
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.children === "" || option.children === null
                        ? null
                        : option.children
                          .toLowerCase()
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {this.state.list_vendor.map((item, index) => (
                      <Select.Option value={item.vendor_id} key={index}>
                        {item.vendor_name}
                      </Select.Option>
                    ))}
                  </Select>
                </div>
                <div className="col-12 mt-2">
                  <Input
                    placeholder="Search"
                    style={{
                      fontSize: "10px",
                      marginBottom: "10px",
                      height: "33px",
                      borderRadius: "0px",
                      maxWidth: "45%",
                    }}
                    onChange={(e) => this.SearchDataAssign(e.target.value)}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  {this.state.active_tab_skill === 1 ? (
                    <Table
                      loading={this.state.loading}
                      size="small"
                      rowKey="key"
                      columns={this.state.columns_employee}
                      dataSource={
                        !this.state.data_assing ? null : this.state.data_assing
                      }
                      style={{
                        whiteSpace: "nowrap",
                        lineHeight: "0.7 !important",
                      }}
                    />
                  ) : null}
                  {this.state.active_tab_skill === 2 ? (
                    <Table
                      loading={this.state.loading}
                      size="small"
                      rowKey="team_id"
                      columns={this.state.columns_team}
                      dataSource={
                        !this.state.data_assing ? null : this.state.data_assing
                      }
                      style={{
                        whiteSpace: "nowrap",
                        lineHeight: "0.7 !important",
                      }}
                    />
                  ) : null}
                </div>
              </div>
            </div>
          </div>
          <div className="col-12">
            <div className="mb-2 text-center">
              <button
                type="reset"
                onClick={() => this.onModal(false)}
                className="btn btn-secondary"
              >
                Close
              </button>
              <button
                className={
                  this.state.disible_assign
                    ? "divhide"
                    : "btn btn-success divshow"
                }
                onClick={() => this.handleSubmit(this.state.modal_data)}
              >
                {"Assign"}
              </button>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
  setDataTabEMP = (index) => {
    this.setState({
      active_tab_skill: index,
      Checktab: index,
      active_emp_skill: 0,
    });
    setTimeout(() => this.onChangEmp(1, 0), 300);
  };
  onChangEmp = async (val, index) => {
    this.setState({
      data_assing: [],
      reloading: true,
      active_emp_skill: index,
    });
    var setTab = ["", "employee", "team"];
    const getTeamAssign = await ServiceApi.post("v2/get_assign_job_ma", {
      select: setTab[this.state.Checktab],
      skill_id: val,
      team_id: null,
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
      project_id: Cookies.get("project_id"),
      sql_where: "operator_id=" + Cookies.get("operator_id"),
    });
    if (this.state.Checktab === "1" || this.state.Checktab === 1) {
      for (
        var i = 0;
        i < getTeamAssign.data.data.result_list_ma_employee.length;
        i++
      ) {
        getTeamAssign.data.data.result_list_ma_employee[i]["key"] = i;
        getTeamAssign.data.data.result_list_ma_employee[i][
          "status_checkbox"
        ] = false;
        getTeamAssign.data.data.result_list_ma_employee[i]["id"] = i;
        for (let r = 0; r < this.state.emp_assign.length; r++) {
          if (
            this.state.emp_assign[r].employee_id ===
            getTeamAssign.data.data.result_list_ma_employee[i].employee_id
          ) {
            getTeamAssign.data.data.result_list_ma_employee[i][
              "status_checkbox"
            ] = true;
          }
        }
      }
      this.setState({
        master_emp: getTeamAssign.data.data.result_list_ma_employee,
        data_assing: getTeamAssign.data.data.result_list_ma_employee,
        reloading: false,
      });
    } else if (this.state.Checktab === "2" || this.state.Checktab === 2) {
      for (
        var i = 0;
        i < getTeamAssign.data.data.result_list_ma_team.length;
        i++
      ) {
        getTeamAssign.data.data.result_list_ma_team[i]["key"] = i;
        getTeamAssign.data.data.result_list_ma_team[i][
          "status_checkbox"
        ] = false;
        getTeamAssign.data.data.result_list_ma_team[i]["id"] = i;
        for (let r = 0; r < this.state.emp_assign.length; r++) {
          if (
            this.state.emp_assign[r].employee_id ===
            getTeamAssign.data.data.result_list_ma_team[i].employee_id
          ) {
            getTeamAssign.data.data.result_list_ma_team[i][
              "status_checkbox"
            ] = true;
          }
        }
      }
      this.setState({
        master_emp: getTeamAssign.data.data.result_list_ma_team,
        data_assing: getTeamAssign.data.data.result_list_ma_team,
        reloading: false,
      });
    }
  };
  CheckboxAsset = (value) => {
    if (value === "all") {
      for (let i = 0; i < this.state.data_assing.length; i++) {
        this.state.data_assing[i]["status_checkbox"] =
          !this.state.data_assing[i]["status_checkbox"];
        if (this.state.data_assing[i]["status_checkbox"] === true) {
          this.state.emp_assign.push(this.state.data_assing[i]);
        } else {
          const result = this.state.emp_assign.filter(
            (data) => data.employee_id !== this.state.data_assing[i].employee_id
          );
          this.setState({
            emp_assign: result,
          });
        }
      }
      this.setState({
        data_assing: this.state.data_assing,
      });
    } else {
      value["status_checkbox"] = !value["status_checkbox"];
      this.setState({
        data_assing: this.state.data_assing,
      });
      if (value["status_checkbox"] === true) {
        this.state.emp_assign.push(value);
      } else {
        const result = this.state.emp_assign.filter(
          (data) => data.employee_id !== value.employee_id
        );
        this.setState({
          emp_assign: result,
        });
      }
    }
  };
  async handleSubmit(modal_data) {
    this.setState({
      disible_assign: true,
    });
    var setAssign = {};
    var setsubmit = [];
    var setTab = ["", "employee_id", "team_id"];
    var setTab_flag = ["", "E", "T"];
    if (modal_data.length > 1) {
      for (var r = 0; r < modal_data.length; r++) {
        for (var i = 0; i < this.state.emp_assign.length; i++) {
          if (setTab_flag[this.state.Checktab] == "E") {
            setAssign = {
              job_no: modal_data[r].job_no,
              emp_code: this.state.emp_assign[i][setTab[this.state.Checktab]],
              create_by: Cookies.get("username"),
              company_id: Cookies.get("companyid"),
              operator_id: Cookies.get("operator_id"),
              job_progress_id: modal_data[r].job_progress_id,
              project_id: Cookies.get("project_id"),
              ...this.state.data_wf[r],
              flag_reassign: "assign",
              emp_or_team: setTab_flag[this.state.Checktab],
              job_id: modal_data[r].job_id,
              team_id: "",
              team_group_id: "",
              vendor_id: this.state.vendor_id,

              plan_start_date:
                this.state.assign_date === undefined
                  ? moment(modal_data[r].plan_start_date).format(
                    "YYYY-MM-DD HH:mm:ss"
                  )
                  : moment(this.state.assign_date).format(
                    "YYYY-MM-DD HH:mm:ss"
                  ),
              plan_end_date:
                modal_data[r].plan_end_date === null
                  ? moment(modal_data[r].plan_start_date)
                    .subtract(7, "d")
                    .format("YYYY-MM-DD HH:mm:ss")
                  : moment(modal_data[r].plan_end_date).format(
                    "YYYY-MM-DD HH:mm:ss"
                  ),
            };
            setsubmit.push(setAssign);
          } else {
            setAssign = {
              job_no: modal_data[r].job_no,
              emp_code: "",
              create_by: Cookies.get("username"),
              company_id: Cookies.get("companyid"),
              operator_id: Cookies.get("operator_id"),
              job_progress_id: modal_data[r].job_progress_id,
              project_id: Cookies.get("project_id"),
              ...this.state.data_wf[r],
              flag_reassign: "assign",
              emp_or_team: setTab_flag[this.state.Checktab],
              job_id: modal_data[r].job_id,
              team_id: this.state.emp_assign[i].team_id,
              team_group_id: this.state.emp_assign[i].team_group_id,
              vendor_id: this.state.vendor_id,

              plan_start_date:
                this.state.assign_date === undefined
                  ? moment(modal_data[r].plan_start_date).format(
                    "YYYY-MM-DD HH:mm:ss"
                  )
                  : moment(this.state.assign_date).format(
                    "YYYY-MM-DD HH:mm:ss"
                  ),
              plan_end_date:
                modal_data[r].plan_end_date === null
                  ? moment(modal_data[r].plan_start_date)
                    .subtract(7, "d")
                    .format("YYYY-MM-DD HH:mm:ss")
                  : moment(modal_data[r].plan_end_date).format(
                    "YYYY-MM-DD HH:mm:ss"
                  ),
            };
            setsubmit.push(setAssign);
          }
        }
      }
    } else {

      for (var i = 0; i < this.state.emp_assign.length; i++) {
        if (setTab_flag[this.state.Checktab] == "E") {
          setAssign = {
            job_no: modal_data[0].job_no,
            emp_code: this.state.emp_assign[i][setTab[this.state.Checktab]],
            create_by: Cookies.get("username"),
            company_id: Cookies.get("companyid"),
            operator_id: Cookies.get("operator_id"),
            job_progress_id: modal_data[0].job_progress_id,
            project_id: Cookies.get("project_id"),
            ...this.state.data_wf[0],
            flag_reassign: "assign",
            emp_or_team: setTab_flag[this.state.Checktab],
            job_id: modal_data[0].job_id,
            team_id: "",
            team_group_id: "",
            vendor_id: this.state.vendor_id,

            plan_start_date:
              this.state.assign_date === undefined
                ? moment(modal_data[0].plan_start_date).format(
                  "YYYY-MM-DD HH:mm:ss"
                )
                : moment(this.state.assign_date).format("YYYY-MM-DD HH:mm:ss"),
            plan_end_date:
              modal_data[0].plan_end_date === null
                ? moment(modal_data[0].plan_start_date)
                  .subtract(7, "d")
                  .format("YYYY-MM-DD HH:mm:ss")
                : moment(modal_data[0].plan_end_date).format(
                  "YYYY-MM-DD HH:mm:ss"
                ),
          };
          setsubmit.push(setAssign);
        } else {
          setAssign = {
            job_no: modal_data[0].job_no,
            emp_code: "",
            create_by: Cookies.get("username"),
            company_id: Cookies.get("companyid"),
            operator_id: Cookies.get("operator_id"),
            job_progress_id: modal_data[0].job_progress_id,
            project_id: Cookies.get("project_id"),
            ...this.state.data_wf,
            flag_reassign: "assign",
            emp_or_team: setTab_flag[this.state.Checktab],
            job_id: modal_data[0].job_id,
            team_id: this.state.emp_assign[i].team_id,
            team_group_id: this.state.emp_assign[i].team_group_id,
            vendor_id: this.state.vendor_id,

            plan_start_date:
              this.state.assign_date === undefined
                ? moment(modal_data[0].plan_start_date).format(
                  "YYYY-MM-DD HH:mm:ss"
                )
                : moment(this.state.assign_date).format("YYYY-MM-DD HH:mm:ss"),
            plan_end_date:
              modal_data[0].plan_end_date === null
                ? moment(modal_data[0].plan_start_date)
                  .subtract(7, "d")
                  .format("YYYY-MM-DD HH:mm:ss")
                : moment(modal_data[0].plan_end_date).format(
                  "YYYY-MM-DD HH:mm:ss"
                ),
          };

          setsubmit.push(setAssign);
        }
      }
    }
    const getTeamAssign = await ServiceApi.post(
      "V2/update_job_ma_to_employee_vendor",
      setsubmit
    );
    if (getTeamAssign.data.result.value === "P") {
      this.setState((state) => {
        const data = state.data.map((item) => {
          if (item.job_id === modal_data[0].job_id) {
            item.job_point = 1;
            this.setState({
              emp_assign: [],
            });
            return item;
          } else {
            return item;
          }
        });
        return {
          data,

        };
      });

      this.setState({
        visible: false,
        visible_success: true,
      })
    } else {
      this.setState({
        disible_assign: false,
      });
      alert("Error Submit");
    }
  }
  renderModalApproveSuccess() {
    const { visible_success } = this.state;
    return (
      <Modal
        title={null}
        centered
        visible={visible_success}
        footer={null}
        closable={false}
      >
        <div className="text-center">
          <img
            src={ServiceApi.absoluteUrl("/img/modal_success.svg")}
            className="img-fluid"
          />
          <h3 className="font-mont-sb font18 c-blue mt-3">
            Assign Job Successful
          </h3>
          <button
            className="btn btn-primary"
            onClick={() => { this.setState({ visible_success: false }); window.location.reload(); }}
          >
            Ok
          </button>
        </div>
      </Modal>
    );
  }
  render() {
    return (
      <LayoutOperation title={""}>
        <div className="row" style={{ marginTop: "64px" }}>
          <div
            className="col-12"
            style={{
              width: "100%",
            }}
          >
            <button
              type="button"
              className="btn btn-warning setBtnAssign"
              id="selectAssign"
              onClick={() => this.onAssignJob()}
            >
              Assign Job
            </button>
            <iframe
              style={{
                width: "100%",
                height: "90vh",
                // overflow: "hidden",
              }}
              src={ServiceApi.absoluteUrl("/SelectAssign/index.html")}
            ></iframe>
          </div>
        </div>
        {this.renderModalAssign()}
        {this.renderModalApproveSuccess()}

      </LayoutOperation>
    );
  }
}

export default SelectAssign;
